// Links into the v9 pages; usable from server and client components.
import { getLocalizedPath } from '@/lib/getLocalizedPath';
import { getVendorSlug } from '@/lib/slug';

/** /book/<brand-slug>-<vendorId>?… */
export function bookPath(locale: string, vendorId: string, name: { en: string; ar: string }, query?: Record<string, string | null | undefined>) {
  const slug = getVendorSlug({ id: vendorId, name_en: name.en, name_ar: name.ar }, locale);
  const q = new URLSearchParams();
  Object.entries(query || {}).forEach(([k, v]) => { if (v) q.set(k, v); });
  const qs = q.toString();
  return getLocalizedPath(locale, `/book/${slug}`) + (qs ? `?${qs}` : '');
}
